// Auto-generated skeleton for Building

import { Address } from "./Address";
import { BuildingType } from "./BuildingType";
import { PropertyManager } from "./PropertyManager";
import { Team } from "./Team";
import { DocumentContainer } from "./DocumentContainer";

export const Building: Api.Building = {
  id: 0,
  hp_id: 0,
  address_id: 0,
  year_of_construction: 0,
  buildings: 0,
  doorways: 0,
  heating_type_id: 0,
  building_type_id: 0,
  hotwater_type_id: 0,
  garage_type_id: 0,
  trashbarrel_type_id: 0,
  is_sold: null,
  is_rented: null,
  search: null,
  team_id: 0,
  propertymanager_id: 0,
  created_at: null,
  updated_at: null,
  address: Address,
  building_type: BuildingType,
  propertymanager: PropertyManager,
  team: Team,
  buildinggroups: [],
  units: [],
  document_container: DocumentContainer,
  images: [],
  assfinet_contracts: [],
  heating_type: BuildingType,
  hotwater_type: BuildingType,
  garage_type: BuildingType,
  trashbarrel_type: BuildingType,
};

